<template>
  <v-container fluid grid-list-md>
    <v-layout row wrap class="mb-4">
      <v-btn round color="primary" @click.prevent="doBack">
        <v-icon left dark>mdi-chevron-left</v-icon>
        Back
      </v-btn>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12>
        <excess-stats :excess="false"></excess-stats>
      </v-flex>
      <v-flex xs12>
        <excess v-model="motorForm.excess" ref="excess"></excess>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-btn round color="primary" @click.prevent="doBack">
        <v-icon left dark>mdi-chevron-left</v-icon>
        Back
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn round color="primary" type="submit" @click.prevent="doProceed" :disabled="proceedDisabled">
        Get Premium
        <v-icon right dark>mdi-chevron-right</v-icon>
      </v-btn>
    </v-layout>
  </v-container>
</template>

<script>
import { AGENCY_QUOTATION_LIFECYCLE, QUOTE_MOTOR_EXCESS } from '@/store/types'
import ExcessStats from '../query/ExcessStats'
import Excess from '../quotation/sub/Excess'
import MessageMixin from '@/mixins/message'
import { SaveQuoteMixin } from '../../shared/saveQuoteMixin'

export default {
  data() {
    return {
      labels: {
        excess: 'Excess'
      },
      motorForm: {
        excess: []
      }
    }
  },
  computed: {
    quoteParam() {
      return this.$store.state.agency.quotation.motorParam
    },
    proceedDisabled() {
      // If excess are not loaded yet or has error, do not proceed
      if (this.quoteParam.excessInit !== 1) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    doBack() {
      this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 1)
      this.$router.push({ name: 'motorQuoteRef' })
    },
    async doProceed() {
      const excessValidation = await this.$refs.excess.doValidate()
      if (excessValidation) {
        this.$store.commit(QUOTE_MOTOR_EXCESS, this.motorForm.excess)
        this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 3)
        this.$router.push({ name: 'motorQuoteRefPremium' })
      } else {
        this.promptFieldCheck()
      }
    },
    async doPartialSave() {
      try {
        this.$store.commit(QUOTE_MOTOR_EXCESS, this.motorForm.excess)
        await this.$store.dispatch('saveQuote')
        return true
      } catch (err) {
        return false
      }
    }
  },
  beforeMount() {
    // Check quote lifecycle (might be using back link or url)
    if (this.$store.state.agency.quotation.quoteLifeCycle !== 2) {
      this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 2)
    }
  },
  mixins: [
    MessageMixin,
    SaveQuoteMixin
  ],
  components: {
    ExcessStats,
    Excess
  }
}
</script>

<style lang="scss">
</style>
